import { useMemo } from "react";
import { useDates } from "dates/DatesContext";
import { Row, Col } from "react-bootstrap";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import moment from "moment";
import { formatPercent } from "utils/formatNumber";
import { trellisPalette } from "components/custom/analytics/palettes";
import Accordion from "components/core/basic/Accordion";

const BuyBoxChart = ({ percentageData }) => {
  const { start, end } = useDates();

  const s = start !== undefined ? start : moment().subtract(30, "days");
  const e = end !== undefined ? end : moment();

  const { buyBoxPercentageOptions, averageData } = useMemo(() => {
    if (!percentageData) {
      return { buyBoxPercentageOptions: {}, averageData: null };
    }
    const dateMap = new Map(percentageData.buy_box.map(([date, value]) => [date, value]));

    const currentDate = moment(s);
    while (currentDate.isSameOrBefore(e)) {
      const formattedDate = currentDate.format("YYYY-MM-DD");
      if (!dateMap.has(formattedDate)) {
        dateMap.set(formattedDate, null);
      }
      currentDate.add(1, "day");
    }

    const sortedData = Array.from(dateMap.entries()).sort((a, b) => moment(a[0]).diff(moment(b[0])));
    const categories = sortedData.map((item) => item[0]);
    const data = sortedData.map((item) => item[1]);

    // const nonNullData = data.filter((d) => d !== null);
    // const averageData = nonNullData.reduce((acc, val) => acc + val, 0) / nonNullData.length;
    // replace null with 0
    const nonNullData = data.map((d) => (d !== null ? d : 0));
    const averageData = nonNullData.reduce((acc, val) => acc + val, 0) / nonNullData.length;

    const buyBoxPercentageOptions = {
      chart: {
        type: "column",
        style: {
          fontFamily: "Roboto",
          fontSize: "14px",
        },
        height: "300px",
      },
      title: {
        text: null,
      },
      xAxis: {
        categories: categories,
        title: {
          text: null,
        },
      },
      yAxis: {
        title: {
          text: "Percentage (%)",
        },
        max: 100,
      },
      series: [
        {
          name: "Buybox %",
          data: data,
          color: trellisPalette[0],
        },
      ],
      legend: {
        enabled: false,
      },
      tooltip: {
        valueSuffix: "%",
      },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: true,
          },
          enableMouseTracking: true,
        },
      },
    };

    return { buyBoxPercentageOptions, averageData };
  }, [percentageData, s, e]);

  return (
    <>
      {percentageData?.buy_box?.length > 0 && (
        <Row>
          <Col xs={12} className="py-3">
            {averageData && (
              <Accordion
                title={`Buy Box Percentage: ${formatPercent(averageData / 100, 2)}`}
                initialExpanded
                marginTop={0}
              >
                <HighchartsReact highcharts={Highcharts} options={buyBoxPercentageOptions} />
              </Accordion>
            )}
          </Col>
        </Row>
      )}
    </>
  );
};

export default BuyBoxChart;
